import { render, staticRenderFns } from "./DistrictSelect.vue?vue&type=template&id=9ed30a86"
import script from "./DistrictSelect.vue?vue&type=script&lang=js"
export * from "./DistrictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports